import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip'
import type { CreditBoosterQuest } from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/useCreditBoosterContent'
import SaleQuestRow from './SaleQuestRow/SaleQuestRow'
import SaleQuestTooltip from './SaleQuestTooltip/SaleQuestTooltip'
import { QuestAnchor, TooltipOverrides } from './styled-components'

interface SaleQuestProps {
  quest: CreditBoosterQuest
  addLabel: string
}

// The tooltip hooks its events onto its direct child, so that child must be a DOM element: QuestAnchor.
const SaleQuest = ({ quest, addLabel }: SaleQuestProps) => {
  if (!quest.description) {
    return (
      <QuestAnchor>
        <SaleQuestRow quest={quest} />
      </QuestAnchor>
    )
  }

  return (
    <StatefulTooltip
      placement={PLACEMENT.left}
      showArrow
      accessibilityType='tooltip'
      overrides={TooltipOverrides}
      content={<SaleQuestTooltip quest={quest} addLabel={addLabel} />}
    >
      <QuestAnchor>
        <SaleQuestRow quest={quest} />
      </QuestAnchor>
    </StatefulTooltip>
  )
}

export default SaleQuest
